import { useState } from "react";

import DstButton from "../../../../components/DstButton/DstButton";
import translate from "../../../../services/Translate";
import { updateJobBlock } from "../../LandingPageJobBlocks.function";
import JobBlockFormFields from "../JobBlockFormFields/JobBlockFormFields";
import { EditJobBlockModalProps } from "./EditJobBlockModal.d";

const EditJobBlockForm = ({ jobBlock, onCancel, onSaved, language }: EditJobBlockModalProps) => {
  const [title, setTitle] = useState(jobBlock.title);
  const [category, setCategory] = useState(jobBlock.category);
  const [link, setLink] = useState(jobBlock.link);
  const [question, setQuestion] = useState(jobBlock.question);
  const [resume, setResume] = useState(jobBlock.resume);
  const [tags, setTags] = useState(jobBlock.tags ?? []);
  const [deprecated, setDeprecated] = useState(jobBlock.deprecated ?? false);
  const [subCategory, setSubCategory] = useState(jobBlock.subcategory ?? "");

  const _isFormValid =
    [title, category, link, question, resume].every((field) => field.trim()) && tags.every((tag) => tag.text?.trim());

  const _saveChanges = () => {
    if (!_isFormValid) return;

    updateJobBlock(
      jobBlock.id,
      {
        title: title.trim(),
        category: category.trim(),
        link: link.trim(),
        question: question.trim(),
        resume: resume.trim(),
        deprecated,
        tags,
        order: jobBlock.order,
        subcategory: subCategory.trim(),
      },
      language,
      onSaved
    );
  };

  return (
    <div className="d-flex flex-column gap-3">
      <JobBlockFormFields
        title={title}
        setTitle={setTitle}
        category={category}
        setCategory={setCategory}
        link={link}
        setLink={setLink}
        question={question}
        setQuestion={setQuestion}
        resume={resume}
        setResume={setResume}
        tags={tags}
        setTags={setTags}
        language={language}
        showDeprecated
        deprecated={deprecated}
        setDeprecated={setDeprecated}
        subCategory={subCategory}
        setSubCategory={setSubCategory}
      />

      {!_isFormValid && (
        <small className="text-muted">
          {translate(language, "PAGES.LANDING_PAGE_JOB_BLOCKS.EDIT_CARD.ERRORS.REQUIRED_FIELDS")}
        </small>
      )}

      <div className="d-flex gap-2 justify-content-end mt-3">
        <DstButton value={translate(language, "GLOBAL.CANCEL")} variant="secondary" clickFunction={onCancel} />
        <DstButton
          value={translate(language, "PAGES.LANDING_PAGE_JOB_BLOCKS.EDIT_CARD.BUTTON.SAVE")}
          clickFunction={_saveChanges}
          disabled={!_isFormValid}
        />
      </div>
    </div>
  );
};

export default EditJobBlockForm;
